import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Pagination, Navigation } from "swiper";

export default class HeroTwo extends React.Component {
    render(){
        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
            <>
                <section className="main-slider main-slider-two">
                    <Swiper 
                        loop={true}
                        slidesPerView={1}
                        effect="fade"
                        autoplay={{delay:   5000}}
                        modules={[EffectFade, Pagination, Navigation]}
                        pagination={{
                            el: "#main-slider-pagination",
                            type: "bullets",
                            clickable: true
                        }}
                        navigation={{
                            nextEl: "#main-slider__swiper-button-next",
                            prevEl: "#main-slider__swiper-button-prev"
                        }} 
                        className="swiper-container thm-swiper__slider">
                        <div className="swiper-wrapper">


                            {/* Start Main Slider Two */}
                            <SwiperSlide className="swiper-slide">
                                <div className="image-layer" style={{backgroundImage: 'url('+publicUrl+'assets/images/slides/slide-1.jpeg)'}}></div>
                                <div className="shape1"></div>

                                <div className="container">
                                    <div className="main-slider-two__content">
                                        <div className="tagline">
                                            <p>Welcome to AgricHub: Farmers</p>
                                        </div>
                                        <div className="title">
                                            <h2>Selling fresh<br /> produce to the<br /> marketplace</h2>
                                        </div>
                                        <div className="btn-box">
                                            <a href="https://store.agrichub.co.za/become-a-vendor" className="thm-btn">
                                                <span className="txt">Apply To Sell</span>
                                                &nbsp;&nbsp;<i className="fa fa-angle-double-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            {/* End Main Slider Two */}

                            {/* Start Main Slider Two */}
                            <SwiperSlide className="swiper-slide">
                                <div className="image-layer" style={{backgroundImage: 'url('+publicUrl+'assets/images/slides/slide-3.jpeg)'}}></div>
                                <div className="shape1"></div>

                                <div className="container">
                                    <div className="main-slider-two__content">
                                        <div className="tagline">
                                            <p>Welcome to AgricHub: Couriers</p>
                                        </div>
                                        <div className="title">
                                            <h2>Distributing <br />independently<br /> to customers</h2>
                                        </div>
                                        <div className="btn-box">
                                            <a href="mailto:support@agrichub.co.za" className="thm-btn">
                                                <span className="txt">Get In Touch</span>
                                                &nbsp;&nbsp;<i className="fa fa-angle-double-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            {/* End Main Slider Two */}

                            {/* Start Main Slider Two */}
                            <SwiperSlide className="swiper-slide">
                                <div className="image-layer" style={{backgroundImage: 'url('+publicUrl+'assets/images/slides/slide-2.jpeg)'}}></div>
                                <div className="shape1"></div>

                                <div className="container">
                                    <div className="main-slider-two__content">
                                        <div className="tagline">
                                            <p>Welcome to AgricHub: Marketplace</p>
                                        </div>
                                        <div className="title">
                                            <h2>Buying produce<br /> directly from<br /> local farmers</h2>
                                        </div>
                                        <div className="btn-box">
                                            <a href="https://store.agrichub.co.za" className="thm-btn">
                                                <span className="txt">Shop Now</span>
                                                &nbsp;&nbsp;<i className="fa fa-angle-double-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            {/* End Main Slider Two */}

                        </div>

                        {/* If we need navigation buttons */}
                        <div className="main-slider__nav">
                            <div className="swiper-button-prev" id="main-slider__swiper-button-next">
                                <i className="icon-left-arrow"></i>
                            </div>
                            <div className="swiper-button-next" id="main-slider__swiper-button-prev">
                                <i className="icon-right-arrow"></i>
                            </div>
                        </div>
                    </Swiper>
                </section>
            </>
        )
    }
}